function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import PropTypes from 'prop-types';
import ActivityIcon from 'svg/activity.svg';
import MealIcon from 'svg/meal.svg';
import MeasurementIcon from 'svg/measurement.svg';
import NoteIcon from 'svg/note.svg';
import InjectionIcon from 'svg/injection.svg';
import PillsIcon from 'svg/pills.svg';
import styles from './RelatedData.pcss';
var _React_PureComponent;
class RelatedData extends (_React_PureComponent = React.PureComponent) {
    get icon() {
        const { data } = this.props;
        const dataType = data.resourceType || data.type;
        switch(dataType){
            case 'Activity':
            case 'activity':
                return /*#__PURE__*/ _jsx(ActivityIcon, {});
            case 'Meal':
            case 'food':
                return /*#__PURE__*/ _jsx(MealIcon, {});
            case 'Medication':
                {
                    if (data.bolusFlag || data.basalFlag) {
                        return /*#__PURE__*/ _jsx(InjectionIcon, {});
                    }
                    return /*#__PURE__*/ _jsx(PillsIcon, {});
                }
            case 'HbA1C':
                return /*#__PURE__*/ _jsx(MeasurementIcon, {});
            case 'Note':
                return /*#__PURE__*/ _jsx(NoteIcon, {});
            case 'injection':
                return /*#__PURE__*/ _jsx(InjectionIcon, {});
            case 'pill':
                return /*#__PURE__*/ _jsx(PillsIcon, {});
            default:
                return null;
        }
    }
    render() {
        const { icon } = this;
        return /*#__PURE__*/ _jsx("div", {
            className: styles.relatedData,
            children: icon
        });
    }
}
_define_property(RelatedData, "propTypes", {
    // Explicit props
    data: PropTypes.shape({
        id: PropTypes.string.isRequired,
        type: PropTypes.oneOf([
            'activity',
            'food',
            'injection',
            'pill'
        ]),
        bolusFlag: PropTypes.bool,
        basalFlag: PropTypes.bool,
        resourceType: PropTypes.string,
        unit: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number
        ]),
        name: PropTypes.string,
        description: PropTypes.string
    })
});
export default withStyles(styles)(RelatedData);
